export default {
  choose_subject: "Fach auswählen",
  show_lesson: "Kurs anzeigen",
  course: "Kurs",
  lessonLink: "Link",
  activityDone: "Erledigte Aktivitäten",
  workToDo: "Vorzubereitende Arbeit",
  generalCourses: "Allgemeine Kurse",
  attachments: "Anhänge",
  attachment: "Anhang",
  download: "Herunterladen",
  "Taught subject": "Unterrichtetes Fach",
  lesson_info:
    "Dieses Menü ermöglicht die Konfiguration von Fächern in Verbindung mit verschiedenen Modulen: Kalender, Kompetenzen, Zeugnis",
};
